import { ArrowRightIcon, ChevronRightIcon, ExternalLinkIcon, ListIcon, PinIcon, PinOffIcon } from 'lucide-react'

import { useQuote } from 'components/quote_explorer/QuoteProvider'
import { IconButton, IconLink, Tooltip } from 'slab'
import { cn } from 'utils'
import { getQuotePlanYear, plansLink } from 'utils/quote_calculations'
import { type QuotingEmployee } from 'utils/web_api.schemas'

import { useQuotingEmployeeContext } from '../QuotingEmployeeContext'

type Props = {
  employee: QuotingEmployee,
  employeeSelected: boolean,
  allowance?: number,
}

function RowButtons ({
  employee,
  employeeSelected,
  allowance,
}: Props) {
  const { pinnedEmployeeIds, handleEmployeePinToggle, isEmployeeInProjectedState } = useQuotingEmployeeContext()
  const { quote } = useQuote()
  const isPinned = pinnedEmployeeIds.includes(employee.id)
  const isProjectedData = isEmployeeInProjectedState?.(employee) ?? false

  return (
    <div className='flex items-center gap-0'>
      <Tooltip
        content={
          <div className='flex items-center gap-1'>
            <ExternalLinkIcon className='w-3 h-3' />
            <span>View plans</span>
          </div>
        }
      >
        <div className='opacity-0 group-hover/row:opacity-100 transition-all duration-200'>
          <IconLink
            icon={ListIcon}
            label='View plans'
            href={
              plansLink(
                employee,
                allowance,
                isProjectedData,
                getQuotePlanYear(quote),
                quote?.preliminary
              )
            }
            target='_blank'
            rel='noopener noreferrer'
          />
        </div>
      </Tooltip>
      <Tooltip content={isPinned ? 'Unpin employee' : 'Pin employee to top of list'}>
        <div className={cn(
          'group/pin opacity-0 group-hover/row:opacity-100 transition-all duration-200',
          isPinned && 'opacity-100'
        )}
        >
          <IconButton
            icon={isPinned ? PinOffIcon : PinIcon}
            label={isPinned ? 'Unpin employee' : 'Pin employee to top of list'}
            data-testid={`pin-button-${employee.id}`}
            onClick={() => handleEmployeePinToggle(employee.id)}
          />
        </div>
      </Tooltip>
      <div className='pl-2'>
        {employeeSelected ? <ArrowRightIcon className='w-4 h-4' /> : <ChevronRightIcon className='w-4 h-4' />}
      </div>
    </div>
  )
}

export default RowButtons
